import { Checkbox, PrimaryButton, TextField } from "@fluentui/react"
import React, { useState } from "react"

import { L10n } from "@encoway/l10n"

import { TranslationConstants } from "../../constants/translationConstants"

export interface IFormData {
    name: string
    lastName: string
    companyName: string
    mailAddress: string
    comment: string
}

interface CsvExportFormProps {
    onSubmit: (data: IFormData) => void
}

export default function CsvExportForm(props: CsvExportFormProps) {
    const [formData, setFormData] = useState<IFormData>({
        name: "",
        lastName: "",
        companyName: "",
        mailAddress: "",
        comment: ""
    })

    function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
        props.onSubmit(formData)
    }

    function handleChange(
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) {
        const { name } = event.currentTarget
        const value = newValue ?? event.currentTarget.value
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }))
    }

    const renderTextField = (
        name: keyof IFormData,
        label: string,
        type: string,
        required: boolean
    ) => (
        <TextField
            name={name}
            label={label}
            type={type}
            required={required}
            value={formData[name]}
            onChange={handleChange}
        />
    )

    return (
        <form
            onSubmit={onSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
            {renderTextField(
                "name",
                L10n.format(TranslationConstants.Dialogs.Mail.NAME),
                "text",
                true
            )}
            {renderTextField(
                "lastName",
                L10n.format(TranslationConstants.Dialogs.Mail.LASTNAME),
                "text",
                true
            )}
            {renderTextField(
                "companyName",
                L10n.format(TranslationConstants.Dialogs.Mail.COMPANY_NAME),
                "text",
                false
            )}
            {renderTextField(
                "mailAddress",
                L10n.format(TranslationConstants.Dialogs.Mail.MAIL),
                "email",
                true
            )}
            <Checkbox
                styles={{
                    root: { marginTop: "1rem" }
                }}
                label={L10n.format(
                    TranslationConstants.Dialogs.Mail.CHECKBOX_TEXT
                )}
                required={true}
            />
            <TextField
                name="comment"
                label={L10n.format(
                    TranslationConstants.Dialogs.Mail.COMMENT_SECTION
                )}
                type="text"
                required={false}
                multiline={true}
                resizable={true}
                onChange={handleChange}
            />
            <PrimaryButton type="submit">
                {L10n.format(TranslationConstants.Toolbar.BUTTON_CSV_EXPORT)}
            </PrimaryButton>
        </form>
    )
}
